export default class CustomerQuotes {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.interacted = false;
            this.autoplayInterval;
            this.interval = 5000;
            this.initDelay = 3000;
            this.openIndex = 0;
            this.getElements();
            this.addEventListeners();
            this.createObserver();
        }
    }

    getElements = () => {
        //Query your elements here
        //this.someElement = this.passedElement.querySelector('.some-element');
        this.title = this.passedElement.querySelector('.container-title');
        this.quotesContainer = this.passedElement.querySelector('.quotes-container');
        this.quotes = this.quotesContainer.querySelectorAll('.quote');
        this.closeQuotes = this.quotesContainer.querySelectorAll('.close');
    }

    startAutoplayQuotes = () => {
        this.autoplayInterval = setInterval(() => {
            if ( this.interacted ) { this.stopAutoplayQuotes(); }
            this.openSingleQuote(this.openIndex);
            this.openIndex === this.quotes.length-1 ? this.openIndex = 0 : this.openIndex++;
        },this.interval);
    }

    stopAutoplayQuotes = () => {
        if ( this.autoplayInterval ) {
            clearInterval(this.autoplayInterval);
            if ( !this.interacted) {
                this.openIndex = 0;
                this.closeAllQuotes();
            } 
        }
    }

    observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            entry.isIntersecting && !this.interacted ? this.startAutoplayQuotes() : this.stopAutoplayQuotes();
        });
    };

    createObserver = () => {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.5
        };

        let observer = new IntersectionObserver(this.observerCallback, options);

        setTimeout(() => {
            if (!this.interacted) {
                observer.observe(this.quotesContainer);
            }
        }, this.initDelay);
    };

    closeAllQuotes = () => {
        this.quotes.forEach(elm => {
            elm.classList.remove('open');
        });
        this.title.classList.remove('open');
    }

    openSingleQuote = (index) => {
        this.closeAllQuotes();
        this.quotes[index].classList.add('open');
        this.title.classList.add('open');
    }

    addEventListeners = () => {
        //Add all event listeners bellow
        this.quotes.forEach((elm, index) => {
            elm.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                this.interacted = true;
                this.openIndex = index;
                const quote = e.currentTarget;
                const classes = quote.classList;
                this.closeAllQuotes();
                classes.add('open');
                this.title.classList.add('open');
            });
        });

        this.closeQuotes.forEach(elm => {
            elm.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                this.interacted = true;
                this.closeAllQuotes();
            });
        });
    }

}